import React, { useState, useEffect } from "react";
import RTBManagementFirstTable from "../RTBManagementComponents/RTBManagementFirstTable";
import axios from "axios";
import { Button, Modal, Divider, Input, Dropdown, Space } from "antd";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Lottie from "lottie-react";
import reloadpage from "../../reloadpage.json";

var SendDataToFirstTable = [];
var ObjSendDataToFirstTable = {};

export default function RTBManagement() {
  const [isClicked, setIsClicked] = useState(false);

  const [Loading, setLoading] = useState(true);
  const [Loading1, setLoading1] = useState(true);

  const [ListOfBillingNames, setListOfBillingNames] = useState([]);
  const [SelectedBillingNames, setSelectedBillingNames] = useState(null);

  const items = localStorage.getItem("Token");
  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  const GetAdvBillingNames = async (event) => {
    try {
      const Array = [];
      const response = await axios.get(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/GetAdvBillingNames`,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
        }
      );
      console.log(response.data);
      for (let i = 0; i < response.data.length; i++) {
        Array.push(response.data[i].id);
      }
      setListOfBillingNames(Array);
      setLoading(false);
    } catch (error) {
      console.log("error in GetAdvBillingNames");
    }
  };

  const GetSearchRtb = async (event) => {
    setLoading1(false);

    SendDataToFirstTable = [];

    var newObj = {
      advertiserName: SelectedBillingNames,
      environment: Environment,
    };
    try {
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/SearchRtb
				`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
        }
      );
      console.log(response.data);
      for (let i = 0; i < response.data.length; i++) {
        ObjSendDataToFirstTable = {
          seatName: response.data[i].seatName,
          advertiserName: response.data[i].advertiserName,
          environment: response.data[i].environment,
          campaignId: response.data[i].campaignId,
          campaignName: response.data[i].campaignName,
          inappRtbCap: response.data[i].inappRtbCap,
          advertiserId: response.data[i].advertiserId,
          id: response.data[i].id,
          seatId: response.data[i].seatId,
        };
        SendDataToFirstTable.push(ObjSendDataToFirstTable);
      }
      console.log(SendDataToFirstTable);
      setLoading1(true);
    } catch (error) {
      console.log("error in GetSearchRtb");
    }
  };
  useEffect(() => {
    GetAdvBillingNames();
  }, []);

  const [Environment, setEnvironment] = useState("mobile_app");
  const handleChangeEnvironment = (event) => {
    setEnvironment(event.target.value);
  };

  const [TotalExpected, setTotalExpected] = useState("");
  const handleChangeTotalExpected = (event) => {
    setTotalExpected(event.target.value);
  };

  const receiveDataFromChildForDelete = (data) => {
    // // console.log(data.dataToSendForDelete);
    console.log(data);
    // setIsModalOpen2(data.dataToSendForDelete);
    // setObjectForDelete(data.id);
    // console.log(ObjectForDelete);
    // console.log("We have one");
  };

  const receiveDataFromChild = (data) => {
    console.log("receiveDataFromChild");
    console.log(data);
    //console.log(data.inputs);

    // setIsModalOpen(data.dataToSend);
    // setDataFromChild(data);
    // setIsModalOpen(true);
    // setTargeting(data.targeting);
    // setGeo(data.geo);
    // setObjectForChange({
    //   ...ObjectForChange,
    //   id: data.id,
    //   geo: data.geo,
    //   seatId: data.seatId,
    //   targeting: data.targeting,
    //   sourceId: data.sourceId,
    //   sourceName: data.sourceName,
    //   environment: data.environment,
    // });
    // console.log(ObjectForChange);
    // console.log("We have one");
  };
  return (
    <div>
      <div style={{ flex: 1, display: "flex" }}>
        <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Environment*</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={Environment}
              label="Environment"
              onChange={handleChangeEnvironment}
            >
              <MenuItem value={"ctv"}>CTV</MenuItem>
              <MenuItem value={"mobile_app"}>Mobile App</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: 30,
            paddingRight: 30,
          }}
        >
          {Loading ? (
            <>Loading...</>
          ) : (
            <>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={ListOfBillingNames}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField {...params} label="Billing Name*" />
                )}
                onChange={(event, newValue) => {
                  // Set the new value when it changes
                  setSelectedBillingNames(newValue);
                }}
              />
            </>
          )}

          {/* <a style={{ color: "black" }}>Billing Name*</a>
          <Input
            style={{ width: "300px" }} // Set the desired width here
            placeholder="Billing Name"
            value={AdBillingName}
            onChange={handleChangeBillingName}
          /> */}
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <a style={{ color: "black" }}>Total Expected</a>
          <Input
            style={{ width: "300px" }} // Set the desired width here
            placeholder="Total Expected"
            value={TotalExpected}
            onChange={handleChangeTotalExpected}
          />
        </div>
        <button
          style={{
            border: "none",
            background: "white",
            cursor: "pointer",
            minWidth: 60,
          }}
          onClick={() => {
            GetSearchRtb();
            setIsClicked(true);
            setTimeout(() => setIsClicked(false), 1000);
          }}
        >
          <Lottie
            loop={isClicked ? true : false}
            autoplay={isClicked ? true : false}
            animationData={reloadpage}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid slice",
              display: "flex",
              background: "white",
              borderRadius: 100,
              justifyContent: "center",
              alignItems: "center",
              margin: 3,
              paddingRight: 5,
              height: 40,
              width: 60,
              minWidth: 60,
            }}
            isPaused={isClicked}
          />
        </button>
      </div>
      {Loading1 ? (
        <>
          <RTBManagementFirstTable
            onSendDataForDelete={receiveDataFromChildForDelete}
            onSendData={receiveDataFromChild}
            SendDataToFirstTable={SendDataToFirstTable}
            // startDate={startDate}
            // endDate={endDate}
          />
        </>
      ) : (
        <>Loading...</>
      )}
    </div>
  );
}
